import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { CategorizedExpertsCatalogueStepData, QuizScreenProps } from '@packages/shared/core/quiz/entities';

type CategorizedExpertsCatalogueQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const CategorizedExpertsCatalogueQuizStep = ({ id, renderQuizScreen }: CategorizedExpertsCatalogueQuizStepProps) => {
  const logger = useLogger();
  const { back, next, stepData, userPreferences } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  return (
    <>
      {renderQuizScreen({
        goBack: back,
        goNext: next,
        userPreferences,
        ...(stepData as CategorizedExpertsCatalogueStepData),
      })}
    </>
  );
};

export default CategorizedExpertsCatalogueQuizStep;
